// extracted by mini-css-extract-plugin
export default {"link":"link_link__afxzN","link-secondary":"link_link-secondary__QSNuR"};